import { TYPE_CALL_STATUS } from '../../../helpers/constant';
// eslint-disable-next-line import/prefer-default-export
export const TAG_OPTIONS = {
  TUTOR_PRIMARY: [
    {
      value: '4',
      text: 'Chuyển sale',
    },
    {
      value: '1',
      text: 'CSĐB',
    },
    {
      value: '3',
      text: 'Gia hạn',
    },
    {
      value: '8',
      text: 'Chờ xếp lớp',
    },
    {
      value: '9',
      text: 'Đã xếp lớp',
    },
    {
      value: '10',
      text: 'Chuyển vận hành',
    },
  ],
  TUTOR_SECONDARY: [
    {
      value: '4',
      text: 'Chuyển sale',
    },
    {
      value: '1',
      text: 'CSĐB',
    },
    {
      value: '3',
      text: 'Gia hạn',
    },
    {
      value: '2',
      text: 'Tự học',
    },
  ],
  BLENDED_PRIMARY: [
    {
      value: '1',
      text: 'CSĐB',
    },
    {
      value: '5',
      text: 'Gia hạn Duo',
    },
    {
      value: '6',
      text: 'Gia hạn Tutor',
    },
    {
      value: '7',
      text: 'Gia hạn Tutor - Duo',
    },
    {
      value: '8',
      text: 'Chờ xếp lớp',
    },
    {
      value: '9',
      text: 'Đã xếp lớp',
    },
    {
      value: '10',
      text: 'Chuyển vận hành',
    },
  ],
  BLENDED_SECONDARY: [
    {
      value: '1',
      text: 'CSĐB',
    },
    {
      value: '5',
      text: 'Gia hạn Duo',
    },
    {
      value: '6',
      text: 'Gia hạn Tutor',
    },
    {
      value: '7',
      text: 'Gia hạn Tutor - Duo',
    },
    {
      value: '2',
      text: 'Tự học',
    },
  ],
};
export const TUTOR_TAB_INDEX = {
  ALL: 0,
  C0: 1,
  TutorTask: 2,
  PeriodicallyCare: 3,
  SpecialCare: 4,
  CourseExtension: 5,
  TransferSales: 6,
};
export const tabAndRelatedInfo = {
  SpecialCare: {
    tab: TUTOR_TAB_INDEX.SpecialCare,
    typeCustomerCare: undefined,
  },
  PeriodicallyCare: {
    tab: TUTOR_TAB_INDEX.PeriodicallyCare,
    typeCustomerCare: TYPE_CALL_STATUS.CHAM_SOC_DINH_KY,
  },
  CourseExtension: {
    tab: TUTOR_TAB_INDEX.CourseExtension,
    typeCustomerCare: TYPE_CALL_STATUS.GIA_HAN,
  },
  TransferSales: {
    tab: TUTOR_TAB_INDEX.TransferSales,
    typeCustomerCare: TYPE_CALL_STATUS.CHUYEN_SALES,
  },
  TutorTask: {
    tab: TUTOR_TAB_INDEX.TutorTask,
    typeCustomerCare: TYPE_CALL_STATUS.CONG_VIEC,
  },
  C0: {
    tab: TUTOR_TAB_INDEX.C0,
    typeCustomerCare: TYPE_CALL_STATUS.C0,
  },
  ALL: {
    tab: TUTOR_TAB_INDEX.ALL,
    typeCustomerCare: TYPE_CALL_STATUS.TAT_CA,
  },
};
export const ieltsyTabPermissions = ['c0-tab-ieltsy_read', 'periodic-tab-ieltsy_read', 'extends-tab-ieltsy_read', 'move-sale-tab-ieltsy_read', 'all-tab-ieltsy_read'];
export const tutorTabPermissions = ['periodic-tab_read', 'extends-tab_read', 'move-sale-tab_read', 'special-care-tutor-student_read', 'tutor-task-tab_read'];
export const secondaryTabPermissions = ['periodic-tab-secondary_read', 'extends-tab-secondary_read', 'move-sale-tab-secondary_read', 'special-care-tutor-student-secondary_read', 'tutor-task-tab-secondary_read'];
export const objPermissionsToTab = {
  'special-care-tutor-student_read': {
    code: 'special-care',
    name: 'Chăm sóc đặc biệt',
  },
  'c0-tab_read': {
    code: 'c0',
    name: 'TA0',
  },
  'periodic-tab_read': {
    code: 'care',
    name: 'Chăm sóc định kỳ',
  },
  'extends-tab_read': {
    code: 'extension',
    name: 'Gia hạn',
  },
  'move-sale-tab_read': {
    code: 'sales',
    name: 'Chuyển sale',
  },
  'all-tab_read': {
    code: 'all',
    name: 'Tất cả',
  },
  'special-care-tutor-student-secondary_read': {
    code: 'special-care',
    name: 'Chăm sóc đặc biệt',
  },
  'periodic-tab-secondary_read': {
    code: 'care',
    name: 'Chăm sóc định kỳ',
  },
  'extends-tab-secondary_read': {
    code: 'extension',
    name: 'Gia hạn',
  },
  'move-sale-tab-secondary_read': {
    code: 'sales',
    name: 'Chuyển sale',
  },
  'c0-tab-ieltsy_read': {
    code: 'c0',
    name: 'C0',
  },
  'periodic-tab-ieltsy_read': {
    code: 'care',
    name: 'Chăm sóc định kỳ',
  },
  'extends-tab-ieltsy_read': {
    code: 'extension',
    name: 'Gia hạn',
  },
  'move-sale-tab-ieltsy_read': {
    code: 'sales',
    name: 'Chuyển sale',
  },
  'all-tab-ieltsy_read': {
    code: 'all',
    name: 'Tất cả',
  },
  'tutor-task-tab_read': {
    code: 'tutor-task',
    name: 'Công việc',
  },
  'tutor-task-tab-secondary_read': {
    code: 'tutor-task',
    name: 'Công việc',
  },
};
export const objPermissionsRoute = {
  'special-care-tutor-student_read': 'SpecialCare',
  'special-care-tutor-student-secondary_read': 'SpecialCare',
  'c0-tab_read': 'C0',
  'periodic-tab_read': 'PeriodicallyCare',
  'periodic-tab-secondary_read': 'PeriodicallyCare',
  'extends-tab_read': 'CourseExtension',
  'extends-tab-secondary_read': 'CourseExtension',
  'move-sale-tab_read': 'TransferSales',
  'move-sale-tab-secondary_read': 'TransferSales',
  'all-tab_read': 'All',
  'c0-tab-ieltsy_read': 'C0',
  'periodic-tab-ieltsy_read': 'PeriodicallyCare',
  'extends-tab-ieltsy_read': 'CourseExtension',
  'move-sale-tab-ieltsy_read': 'TransferSales',
  'all-tab-ieltsy_read': 'All',
  'tutor-task-tab_read': 'TutorTask',
  'tutor-task-tab-secondary_read': 'TutorTask',
};
export const statusTicket = [
  { id: 1, name: 'Mới', color: '#03A9F4' },
  { id: 2, name: 'Đang xử lý', color: '#FF6D00' },
  { id: 3, name: 'Chờ duyệt', color: '#FFC400' },
  { id: 4, name: 'Tạm dừng', color: '#A0A0A0' },
  { id: 5, name: 'Hoàn thành', color: '#5AC725' },
  { id: 6, name: 'Hủy', color: '#FF3D00' },
];
export const TUTOR_ACTION_PERMISSION = [
  {
    name: 'PeriodicallyCare',
    tabIndex: TUTOR_TAB_INDEX.PeriodicallyCare,
    actions: [
      {
        permission: 'periodic-tab-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'periodic-tab-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
      {
        permission: 'periodic-tab-change-early-extend_read',
        title: 'Chuyển gia hạn sớm',
        type: 'move_to_early_extension',
      },
    ],
  },
  {
    name: 'CourseExtension',
    tabIndex: TUTOR_TAB_INDEX.CourseExtension,
    actions: [
      {
        permission: 'extends-tab-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'extends-tab-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
    ],
  },
  {
    name: 'TransferSales',
    tabIndex: TUTOR_TAB_INDEX.TransferSales,
    actions: [
      {
        permission: 'move-sale-tab-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'move-sale-tab-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
    ],
  },
];
export const TUTOR_SECONDARY_ACTION_PERMISSION = [
  {
    name: 'PeriodicallyCare',
    tabIndex: TUTOR_TAB_INDEX.PeriodicallyCare,
    actions: [
      {
        permission: 'periodic-tab-secondary-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'periodic-tab-secondary-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
      {
        permission: 'periodic-tab-secondary-change-early-extend_read',
        title: 'Chuyển gia hạn sớm',
        type: 'move_to_early_extension',
      },
    ],
  },
  {
    name: 'CourseExtension',
    tabIndex: TUTOR_TAB_INDEX.CourseExtension,
    actions: [
      {
        permission: 'extends-tab-secondary-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'extends-tab-secondary-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
    ],
  },
  {
    name: 'TransferSales',
    tabIndex: TUTOR_TAB_INDEX.TransferSales,
    actions: [
      {
        permission: 'move-sale-tab-secondary-change-extend-sale_read',
        title: 'Chuyển sale gia hạn',
        type: 'change_sale',
      },
      {
        permission: 'move-sale-tab-secondary-change-class-manager_read',
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
      },
    ],
  },
];
export const POPUP_DETAIL_TAB_INDEX = {
  CARE: 0,
  STUDY_HISTORY: 1,
  ORDER: 2,
  TASK: 3,
  EXCHANGE: 4,
  LOGS: 5,
  TICKET: 6,
  NOTE: 7,
  ACTIVITY: 8,
};
export const GRADING_SCALE = {
  0: 'Số câu đúng/ Tổng số câu',
  1: 'Điểm theo band ielts',
  2: 'Hệ điểm 100',
  3: 'Không chấm',
  4: 'Hệ điểm 10',
};
export const PRODUCT_TRIAL_TYPE = {
  SKU_DUO: 'sku_duo',
  SKU_TUTOR: 'sku_tutor',
  SKU_COMBO: 'sku_combo',
};
export const SPECIAL_ENGLISH_CODE = ['TA-SGK'];
export const subjectIdTutorSortClass = {
  MON_TOAN: 1,
  MON_TIENG_ANH: 5,
  MON_NGU_VAN: 15,
  MON_KHAC: 99,
};
export const LOP_NHAP = 7;
const GV_VIETNAM = 1;

export const TRANG_THAI_LOP_TAM_NGHI = 6;
export const TRANG_THAI_LOP_CHO_KHAI_GIANG = 0;
export const TRANG_THAI_LOP_DANG_HOC = 1;
export const TRANG_THAI_LOP_DA_KET_THUC = 2;

export const TRANG_THAI_LOP = [
  {
    id: TRANG_THAI_LOP_CHO_KHAI_GIANG,
    name: 'Chờ khai giảng',
  },
  {
    id: TRANG_THAI_LOP_DANG_HOC,
    name: 'Đang học',
  },
  {
    id: TRANG_THAI_LOP_DA_KET_THUC,
    name: 'Đã kết thúc',
  },
  {
    id: TRANG_THAI_LOP_TAM_NGHI,
    name: 'Tạm nghỉ',
  },
  {
    id: 7,
    name: 'Lớp nháp',
  },
];
export const TRANG_THAI_LOP_NHAP = [
  {
    id: 7,
    name: 'Lớp nháp',
  },
];
export const SUBJECTS_SORT_CLASS = [
  {
    id: 5,
    code: 'TA',
    name: 'TIẾNG ANH',
  },
  {
    id: 1,
    code: 'TOAN',
    name: 'TOÁN',
  },
  {
    id: 15,
    code: 'VAN',
    name: 'NGỮ VĂN',
  },
];
export const LOAI_LOP_TOAN = [
  { id: 1, name: '1-1' },
  { id: 2, name: '1-2' },
  { id: 3, name: '1-3' },
  { id: 4, name: '1-4' },
  { id: 5, name: '1-5' },
  { id: 6, name: '1-6' },
  { id: 7, name: '1-7' },
  { id: 8, name: '1-8' },
  { id: 9, name: '1-9' },
  { id: 10, name: '1-10' },
  { id: 15, name: '1-15' },
];
export const LOAI_LOP = [
  { id: 1, name: '1-1' },
  { id: 2, name: '1-2' },
  { id: 3, name: '1-3' },
  { id: 4, name: '1-4' },
  { id: 5, name: '1-5' },
  { id: 6, name: '1-6' },
  { id: 7, name: '1-7' },
  { id: 8, name: '1-8' },
  { id: 9, name: '1-9' },
  { id: 10, name: '1-10' },
  { id: 15, name: '1-15' },
];
export const subjectIdTACrm = 3;
export const LOAI_GIAOVIENT_VN = [
  {
    id: GV_VIETNAM,
    name: 'Việt Nam',
  },
];
const GV_MIEN_BAC = 1;
const GV_MIEN_TRUNG = 2;
const GV_MIEN_NAM = 3;

export const VUNG_MIEN_GV = [
  {
    id: GV_MIEN_BAC,
    name: 'Miền Bắc',
  },
  {
    id: GV_MIEN_TRUNG,
    name: 'Miền Trung',
  },
  {
    id: GV_MIEN_NAM,
    name: 'Miền Nam',
  },
];
export const levelEnglish = [
  { id: 0, name: 'Level 0' },
  { id: 1, name: 'Level 1' },
  { id: 2, name: 'Level 2' },
  { id: 3, name: 'Level 3' },
  { id: 4, name: 'Level 4' },
  { id: 5, name: 'Level 5' },
  { id: 6, name: 'Level 6' },
  { id: 7, name: 'Level 7' },
  { id: 8, name: 'Level 8' },
  { id: 9, name: 'Level 9' },
  { id: 10, name: 'Level 10' },
  { id: 11, name: 'Level 11' },
  { id: 12, name: 'Level 12' },
  { id: 14, name: 'Level 13' },
  { id: 15, name: 'Level 14' },
  { id: 16, name: 'Level 15' },

  { id: 17, name: 'Kindie 1' },
  { id: 18, name: 'Kindie 2' },
  { id: 19, name: 'Kindie 3' },
  { id: 13, name: 'Speaking Tour' },
];
export const LevelMath = [
  { id: 101, name: 'Nền tảng 1' },
  { id: 102, name: 'Nền tảng 2' },
  { id: 103, name: 'Tiêu chuẩn' },
  { id: 104, name: 'Nâng cao' },
  { id: 105, name: 'Tài năng' },

];
export const levelLiteratureId = 200;
export const LevelLiterature = [
  { id: levelLiteratureId, name: 'Tất cả' },
];
export const LOP_GV = [
  { id: 0, name: 'Lớp <1' },
  { id: 1, name: 'Lớp 1' },
  { id: 2, name: 'Lớp 2' },
  { id: 3, name: 'Lớp 3' },
  { id: 4, name: 'Lớp 4' },
  { id: 5, name: 'Lớp 5' },
  { id: 6, name: 'Lớp 6' },
  { id: 7, name: 'Lớp 7' },
  { id: 8, name: 'Lớp 8' },
  { id: 9, name: 'Lớp 9' },
  { id: 10, name: 'Lớp 10' },
  { id: 11, name: 'Lớp 11' },
  { id: 12, name: 'Lớp 12' },
];
export const STATUS_HOC_THU = 14;
export const GIO_THUONG = 0;
export const GIO_VANG = 1;
export const GIO_TAT_CA = 2;
export const hourTypeConfig = {
  [GIO_THUONG]: 'regular',
  [GIO_VANG]: 'golden',
  [GIO_TAT_CA]: 'all',
};
export const CLASS_ASSIGNMENT_CHANGE_REASON = {
  ASSIGN_LATER: 1, // Xếp lớp sau
  NO_TEACHER: 2, // không tìm được giáo viên
  OVERDUE: 3, // quá hạn
  STUDENT_REMOVED_FROM_CLASS: 4, // học viên bị xóa khỏi lớp
  OTHER: 5, // lý do khác
};
export const CLASS_ASSIGNMENT_CHANGE_REASON_OPTION = [
  {
    value: 1,
    text: 'Phụ huynh hẹn xếp lớp sau',
    selectable: true,
  },
  {
    value: 2,
    text: 'Không tìm được giáo viên',
    selectable: true,
  },
  {
    value: 3,
    text: 'Quá hạn',
    selectable: false,
  },
  {
    value: 4,
    text: 'Học viên bị xóa khỏi lớp',
    selectable: false,
  },
  {
    value: 5,
    text: 'Lý do khác',
    selectable: true,
  },
];
export const GENDER = {
  MALE: 1,
  FEMALE: 0,
  OTHER: 2,
};
export const REGION = [
  {
    id: 1,
    name: 'B',
    color: '#219653',
  },
  {
    id: 2,
    name: 'T',
    color: '#9B51E0',
  },
  {
    id: 3,
    name: 'N',
    color: '#EB5757',
  },
];
export const UPDATE_CARE_TAG = {
  CHUYEN_VAN_HANH: 10,
  DA_XEP_LOP: 9,
};
export const subLevel = [{ id: 1, name: 'A' }, { id: 2, name: 'B' }, { id: 3, name: 'C' }];
export const PRODUCT_COMBO_ORDER_TYPE = {
  1: 'Mua mới',
  2: 'Gia hạn',
};
export const SORT_CLASS_PROGRAMS_NAME = ['Chương trình CAM'];
